






























































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { IDynamicColumn } from "@/models/dynamicColumns";

@Component
export default class ManageColumnsModal extends Vue {
  public $refs!: {
    tabs: any;
    filter: HTMLFormElement;
  };
  @Prop({ required: true })
  public availableColumns!: IDynamicColumn[];
  @Prop({ required: true })
  public selectedColumns!: string[];
  @Prop({ required: true })
  public defaultColumns!: string[];

  public sortElems: string[] = [];
  public filter = "";
  public isProcessing = false;

  public sortableOptions: {
    chosenClass: string;
    handle: string;
  } = {
    chosenClass: "is-chosen",
    handle: ".drag-and-drop"
  };

  public locallySelectedColumns: string[] = [];
  public activeTab = 0;

  public created() {
    this.locallySelectedColumns = this.$_.clone(this.selectedColumns);
  }

  public mounted() {
    this.autofocusFilter();
  }

  public autofocusFilter() {
    this.$nextTick(() => {
      this.$refs.filter.focus();
    });
  }

  public highlight = (needle, haystack) =>
    haystack.replace(
      new RegExp(needle, "gi"),
      str => `<span class="has-text-info">${str}</span>`
    );

  public get availableColumnsFiltered() {
    return this.$_.sortBy(
      this.$_.filter(this.availableColumns, column => {
        return (column.label as string)
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      }),
      column => column.label
    );
  }

  public get isChanged() {
    return !this.$_.isEqual(this.locallySelectedColumns, this.selectedColumns);
  }

  public get isDefault() {
    return this.$_.isEqual(this.locallySelectedColumns, this.defaultColumns);
  }

  public setDefault() {
    this.locallySelectedColumns = this.$_.clone(this.defaultColumns);
  }

  public save() {
    this.isProcessing = true;
    setTimeout(() => {
      if (this.isChanged)
        this.$emit("columns-changed", this.locallySelectedColumns);
      this.$emit("close");
    }, 250);
  }

  public get tableColumns() {
    const columns = this.$_.filter(
      this.$_.cloneDeep(this.availableColumns),
      column => this.locallySelectedColumns.includes(column.id)
    );

    return this.$_.sortBy(columns, column =>
      this.locallySelectedColumns.indexOf(column.id)
    );
  }

  // Watch
  @Watch("locallySelectedColumns", { immediate: true })
  public updateSortableData() {
    this.sortElems = this.$_.cloneDeep(this.locallySelectedColumns);
  }

  public onDragDrop() {
    this.locallySelectedColumns = this.$_.cloneDeep(this.sortElems);
  }

  public tabsChanged() {
    this.$nextTick(() => {
      this.$refs.tabs.$parent.$el.querySelector(
        ".modal-card-body"
      ).scrollTop = 0;
    });
  }

  public get allAreSelected() {
    return (
      this.locallySelectedColumns.length ===
      this.availableColumnsFiltered.length
    );
  }

  public toggleColumn(column) {
    if (this.locallySelectedColumns.includes(column)) {
      return this.locallySelectedColumns.splice(
        this.locallySelectedColumns.indexOf(column),
        1
      );
    }
    this.locallySelectedColumns.push(column);
  }

  public toggleAll() {
    if (this.allAreSelected) {
      this.locallySelectedColumns = [];
      return;
    }

    this.availableColumnsFiltered.forEach(column => {
      if (this.locallySelectedColumns.includes(column.id)) {
        return;
      }
      this.locallySelectedColumns.push(column.id);
    });
  }
}
